import { withInstall } from "../utils/index.mjs";
import _CollapseItem from "./CollapseItem.mjs";
const CollapseItem = withInstall(_CollapseItem);
var stdin_default = CollapseItem;
import { collapseItemProps } from "./CollapseItem.mjs";
export {
  CollapseItem,
  collapseItemProps,
  stdin_default as default
};
